"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContainer = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const react_1 = require("react");
const MenuShell_1 = require("../../../components/MenuShell");
const inversify_1 = require("inversify");
const ui_core_api_gateway_1 = require("@desygner/ui-core-api-gateway");
function fetchImageTemplates(apiGateway, payload) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const payloadString = `number_of_photos=${payload.numberOfPhotos}&width=${payload.width}&height=${payload.height}`;
        const response = yield apiGateway.fetch('POST', '/grid/fetch', payloadString);
        return response;
    });
}
function loadImageTemplates(apiGateway, payload, width, height, numberOfPhotos, processSVGData, imageTemplateFallback, callback) {
    fetchImageTemplates(apiGateway, payload)
        .then((response) => {
        const responseData = response.MESSAGE;
        const imageTemplates = [];
        for (const data of responseData) {
            const processedData = processSVGData(data);
            const imageTemplate = {
                source: '',
                title: processedData.name,
                data: '',
                details: {
                    numberOfPhotos,
                    width,
                    height,
                    defs: processedData.defs,
                    content: processedData.svg,
                },
            };
            imageTemplates.push(imageTemplate);
        }
        callback(imageTemplates);
    })
        .catch(() => {
        const imageTemplates = imageTemplateFallback || [];
        callback(imageTemplates);
    });
}
function AppContainer({ apiConfiguration, thumbnailWidth, thumbnailHeight, onImageTemplateClick, processSVGData, imageTemplateFallback, }) {
    const [appState, setAppState] = (0, react_1.useState)({
        numberOfPhotos: 1,
        imageTemplates: [],
    });
    const apiGateway = (0, react_1.useMemo)(() => {
        const container = new inversify_1.Container();
        container.load(ui_core_api_gateway_1.container);
        const apiGateway = container.get(ui_core_api_gateway_1.TYPES.ApiGateway);
        apiGateway.configure(apiConfiguration.baseUrl, apiConfiguration.userToken, apiConfiguration.company);
        return apiGateway;
    }, []);
    const loadImageTemplatesCallback = (0, react_1.useCallback)((newImageTemplates) => {
        setAppState((prevState) => {
            const newState = {
                numberOfPhotos: prevState.numberOfPhotos + 1,
                imageTemplates: [...prevState.imageTemplates, ...newImageTemplates],
            };
            return newState;
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const initialNumberOfPhotos = 1;
        const payload = {
            width: thumbnailWidth,
            height: thumbnailHeight,
            numberOfPhotos: initialNumberOfPhotos,
        };
        loadImageTemplates(apiGateway, payload, thumbnailWidth, thumbnailHeight, initialNumberOfPhotos, processSVGData, imageTemplateFallback, loadImageTemplatesCallback);
    }, []);
    return ((0, jsx_runtime_1.jsx)(MenuShell_1.MenuShell, { visible: true, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Grid, { cardType: 'svg', items: appState.imageTemplates, onClick: onImageTemplateClick, columns: 1 }) }));
}
exports.AppContainer = AppContainer;
//# sourceMappingURL=App.js.map